import React from "react";
import CustomTypography from "../CustomComponents/CustomTypography/CustomTypography";
import CustomGrid from "../CustomComponents/CustomGrid/CustomGrid";
import CustomPaper from "../CustomComponents/CustomPaper/CustomPaper";
import CustomCard from "../CustomComponents/CustomCard/CustomCard";
import CustomCardContent from "../CustomComponents/CustomCardContent/CustomCardContent";
import { useStyles } from "../../assets/jss/Dashboard";
import { useTheme } from "@material-ui/core/styles";
import CustomSkeleton from "../CustomComponents/CustomSkeleton/CustomSkeleton";
import CustomCircularProgress from "../CustomComponents/CustomCircularProgress/CustomCircularProgress";
import ErrorAlert from "../ErrorAlert/ErrorAlert";
import { getPenaltyPoints } from "../../services/PenaltyPoints";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import CustomBox from "../CustomComponents/CustomBox/CustomBox";


export default function DashboardPenaltyCard(props) {
  const params = useParams();
  const { t } = useTranslation();
  const classes = useStyles();
  const theme = useTheme();
  const [eventTypes, setEventTypes] = React.useState<any>();
  const [eventCode, setEventCode] = React.useState<any>();
  const [penaltyPoints, setPenaltyPoints] = React.useState<any>();
  const [isApiFailed, setIsApiFailed] = React.useState(false);
  const [isApi, setIsApi] = React.useState(false);
  const [statusValue, setStatusValue] = React.useState();
  const [alertMessage, setAlertMessage] = React.useState("");
  const [isAlertOpen, setIsAlertOpen] = React.useState(false);

  const changeApiStatusCodeFunc = (status) => {
    if (status.code && status.code !== 0 && status.code !== 200) {
      setStatusValue(status.code);
      setAlertMessage(
        status.message
          ? status.message
          : `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`
      );
      setIsAlertOpen(true);
    }
  };

  React.useEffect(() => {
    setEventTypes(props.eventTypes);
    setEventCode(props.eventCode);
  }, [props]);

  async function getPenaltyPoint() {
    let code = [];
    if (eventCode === "DRIVER_DISTRACTION") {
      code.push("DISTRACTION");
    } else if (eventCode === "SPEEDING_AND_DISTRACTION") {
      code.push("SPEEDING");
      code.push("DISTRACTION");
    } else {
      code.push(eventCode);
    }
    var speedingEvent = [];
    eventTypes.forEach(x => { code.forEach(o => { if (x.code === o) speedingEvent.push(x.id) }) });
    setStatusValue(null);
    setAlertMessage("");
    setIsApi(true);
    const data = await getPenaltyPoints(speedingEvent, params);
    if (
      data &&
      (data.status.code === 0 ||
        data.status.code === 200 ||
        data.status.code === 201) &&
      data.content
    ) {
      var findSpeedingPoint: any = [];
      if (data.content.length === 1) {
        data.content.find((item) =>
          speedingEvent.forEach(x => { if (item.eventTypeId === x) findSpeedingPoint.push(item) })
        );
      } else {
        var temp = { eventTypeId: "", penaltyPoint: 0 };
        data.content.map(item => temp.penaltyPoint += item.penaltyPoint);
        findSpeedingPoint.push(temp);
      }
      setPenaltyPoints(
        findSpeedingPoint ? findSpeedingPoint[0].penaltyPoint : "N/A"
      );
      setIsApi(false);
      setIsApiFailed(false);
    } else {
      setIsApi(false);
      setIsApiFailed(true);
      changeApiStatusCodeFunc(data.status);
    }
  }

  React.useEffect(() => {
    if (eventTypes) {
      getPenaltyPoint();
    }
  }, [eventTypes, eventCode]);

  function getEventTypeFromCode(eventCode: any) {
    let event: string;
    event = "SPEEDING";
    if (eventCode === "SPEEDING")
      event = "SPEEDING"
    else if (eventCode === "BRAKING")
      event = "BRAKING"
    else if (eventCode === "CORNERING")
      event = "CORNERING"
    else if (eventCode === "DRIVER_DISTRACTION")
      event = "DRIVER_DISTRACTION"
    else if (eventCode === "ACCELERATION")
      event = "ACCELERATION"
    else if (eventCode === "SPEEDING_AND_DISTRACTION")
      event = "SPEEDING_AND_DISTRACTION"

    return event;
  }

  return (
    <>
      <CustomPaper square elevation={0}>
        <CustomCard elevation={0}>
          <CustomCardContent
            className={classes.penaltyPointsCardContent}
            style={(eventCode !== "DRIVER_DISTRACTION") ?
              { backgroundImage: `linear-gradient(to right, rgba(255, 255, 255), rgba(253, 223, 223))`, padding: "0px" }
              :
              { backgroundImage: `linear-gradient(to right, rgba(255, 255, 255), rgba(255, 242, 209))`, padding: "0px" }
            }
          >
            <CustomGrid
              container
              // justifyContent={isMobile ? "center" : "space-between"}
              justifyContent={"space-between"}
              className={classes.justifyCenter}
              alignItems="center"
              spacing={0}
              style={{ padding: theme.spacing(0, 0, 0, 5) }}
            >
              <CustomGrid item>
                <CustomTypography
                  paragraph={true}
                  className={classes.potentialPenaltyText}
                >
                  {`${t("TOTAL_NUMBER_OF_POTENTIAL_POINTS_FROM")} ${t(getEventTypeFromCode(eventCode))} ${t("EVENTS")}`}
                  {/* {`Total Number of potential penalty points from ${getEventTypeFromCode(eventCode)} events`} */}
                </CustomTypography>
              </CustomGrid>
              <CustomGrid item>
                {isApi && <CustomBox style={{ minHeight: 80, alignItems: "center", display: "flex", padding: "0 24px 0 0" }}><CustomCircularProgress /></CustomBox>}
                {!isApi && isApiFailed && (
                  <CustomSkeleton
                    className={classes.potenitalPenalityChipSkeleton}
                    animation="wave"
                    width={100}
                    height={64}
                  />
                )}
                {!isApi && !isApiFailed && penaltyPoints >= 0 && (
                  <CustomBox
                    className={(eventCode !== "DRIVER_DISTRACTION") ? classes.penaltyPointsDashboard : classes.penaltyPoints}
                  >
                    <CustomTypography
                      component="h1"
                      variant="h5"
                      className={classes.penaltyPointsText}
                    >
                      {penaltyPoints}
                    </CustomTypography>
                  </CustomBox>
                )}
              </CustomGrid>
            </CustomGrid>
          </CustomCardContent>
        </CustomCard>
      </CustomPaper >
      <ErrorAlert
        code={statusValue}
        message={alertMessage}
        isOpen={isAlertOpen}
        isClose={(isClose) => setIsAlertOpen(!isClose)}
      />
    </>
  );
}
